import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { IcArrowUp, IcSave, IcArrowLeft } from "../../Icons";
import axios from "axios";
import { Button, Input, Label, Row, Col } from "reactstrap";
import Header from "../../layout/Header/Header";
import Swal from "sweetalert2";
import moment from "moment";

const fmt = (v) =>
  new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(Number(v) || 0);

function SalidasCreate() {
  const { user } = useContext(AuthContext);
  const URL_SALIDAS = process.env.REACT_APP_URL_SALIDAS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_CUENTAS = process.env.REACT_APP_URL_CUENTAS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const auth = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };

  const [clientes, setClientes] = useState([]);
  const [cuentas, setCuentas] = useState([]);

  const [fecha, setFecha] = useState(moment().format("YYYY-MM-DD"));
  const [selectedCliente, setSelectedCliente] = useState("");
  const [selectedCuenta, setSelectedCuenta] = useState("");
  const [tipo, setTipo] = useState("Transferencia");
  const [monto, setMonto] = useState(0);
  const [status, setStatus] = useState("Pendiente");
  const [observaciones, setObservaciones] = useState("");
  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    axios.get(URL_CLIENTES, auth).then((r) => setClientes(r.data)).catch(() => {});
    axios.get(URL_CUENTAS, auth).then((r) => setCuentas(r.data)).catch(() => {});
  }, []); // eslint-disable-line

  const cliente = clientes.find((a) => a._id === selectedCliente);
  const saldoActual = cliente?.saldo || 0;
  const saldoResultante = saldoActual - (Number(monto) || 0);

  function guardar() {
    if (!fecha || !selectedCliente || !(Number(monto) > 0)) {
      Swal.fire("Falta información", "Fecha, cliente y monto son obligatorios", "warning");
      return;
    }
    setValidaBoton(false);

    axios
      .post(URL_SALIDAS, {
        fecha,
        clientes: selectedCliente,
        cuentas: selectedCuenta || undefined,
        tipo,
        monto: Number(monto),
        status,
        observaciones: observaciones || "NA",
      }, auth)
      .then(() => {
        axios.post(URL_LOGS, {
          tipo: "Crear Salida",
          detalle: `${cliente?.nombre_comercial || ""} ${monto}`,
          user: user.id,
        }, auth);
        Swal.fire("¡Listo!", "Salida registrada con éxito", "success");
        setTimeout(() => { window.location.href = "/ListadoSalidas"; }, 1200);
      })
      .catch((error) => {
        setValidaBoton(true);
        Swal.fire({
          icon: "error", title: "Oops...", text: "Something went wrong!",
          footer: `${error.response?.data?.message || ""}`,
        });
      });
  }

  return (
    <>
      <Header />
      {user.menu_salidas ? (
        <div className="card container col-sm-10">
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <IcArrowUp style={{ marginRight: 8, color: "#dc2626" }} />
                Nueva Salida
              </h3>
              <p className="page-subtitle">Entrega al cliente, baja su saldo</p>
            </div>
            <div className="page-actions">
              <Button color="secondary" size="sm" href="/ListadoSalidas">
                <IcArrowLeft style={{ marginRight: 6 }} />
                Regresar
              </Button>
            </div>
          </div>

          <div className="form-section">
            <div className="form-section-header">
              <span className="form-section-title">Datos de la salida</span>
            </div>
            <div className="form-section-body">
              <Row>
                <Col md={3}>
                  <Label>Fecha</Label>
                  <Input type="date" value={fecha} onChange={(e) => setFecha(e.target.value)} />
                </Col>
                <Col md={4}>
                  <Label>Cliente</Label>
                  <Input type="select" value={selectedCliente}
                         onChange={(e) => setSelectedCliente(e.target.value)}>
                    <option value="">Selecciona</option>
                    {clientes
                      .filter((a) => a.is_active === "Si")
                      .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
                      .map((a) => <option key={a._id} value={a._id}>{a.nombre_comercial}</option>)}
                  </Input>
                </Col>
                <Col md={2}>
                  <Label>Tipo</Label>
                  <Input type="select" value={tipo} onChange={(e) => setTipo(e.target.value)}>
                    <option value="Transferencia">Transferencia</option>
                    <option value="Efectivo">Efectivo</option>
                  </Input>
                </Col>
                <Col md={3}>
                  <Label>Monto</Label>
                  <Input type="number" value={monto} onChange={(e) => setMonto(e.target.value)} />
                </Col>
              </Row>
              <Row className="mt-2">
                <Col md={3}>
                  <Label>Cuenta</Label>
                  <Input type="select" value={selectedCuenta}
                         onChange={(e) => setSelectedCuenta(e.target.value)}>
                    <option value="">Selecciona</option>
                    {cuentas
                      .filter((a) => a.is_active === "Si")
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => <option key={a._id} value={a._id}>{a.name}</option>)}
                  </Input>
                </Col>
                <Col md={3}>
                  <Label>Estatus</Label>
                  <Input type="select" value={status} onChange={(e) => setStatus(e.target.value)}>
                    <option value="Pendiente">Pendiente</option>
                    <option value="Cobrado">Cobrado</option>
                  </Input>
                </Col>
                <Col md={6}>
                  <Label>Observaciones</Label>
                  <Input type="text" value={observaciones}
                         onChange={(e) => setObservaciones(e.target.value)} />
                </Col>
              </Row>
            </div>
          </div>

          {selectedCliente ? (
            <div className="total-bar">
              <span>Saldo actual: <strong>{fmt(saldoActual)}</strong></span>
              <span style={{ marginLeft: 24, color: saldoResultante < 0 ? "#dc2626" : "inherit" }}>
                Saldo después de la salida: <strong>{fmt(saldoResultante)}</strong>
              </span>
            </div>
          ) : null}

          <div className="submit-bar">
            <Button color="success" onClick={guardar} disabled={!validaBoton}>
              <IcSave style={{ marginRight: 6 }} />
              Guardar Salida
            </Button>
          </div>
        </div>
      ) : undefined}
    </>
  );
}

export default SalidasCreate;
